// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { DECLINE_ONBOARDING_ENDPOINT_CONFIGURATION } from './constants/session-expire-timeout.services.constants';

const declineOrderService = async (): Promise<[null, Response]> =>
  apiUtils.post({ ...DECLINE_ONBOARDING_ENDPOINT_CONFIGURATION });

export { declineOrderService };
